"use client";
import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import CarouselArtist from "@/modules/book-body/components/carousel-artist";
import Slider from "react-slick";
import { ResponseTypes } from "@/types/constants";
import authorAPI from "@/services/author_api";
import { definitions } from "@/services/metruyenvl";

function SliderArtist({ book }: { book?: definitions["do.BookDO"] }) {
    const [listSliderAuth, setListSliderAuth] = useState<definitions["do.BookDO"][]>([]);
    useEffect(() => {
        const getBooks = async () => {
            try {
                const res: ResponseTypes = await authorAPI.getBooks(book?.author?.slug ?? "", 1, 5);
                setListSliderAuth(res.data);
            } catch (error) {
                console.log(error);
            }
        };
        getBooks();
    }, []);
    const settings: any = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return (
        <Slider {...settings}>
            {listSliderAuth.map((books) => {
                return (
                    <div key={book?.id} className="rounded-lg p-5">
                        <CarouselArtist book={books} />
                    </div>
                );
            })}
        </Slider>
    );
}
export default SliderArtist;
